export default __webpack_public_path__ + "static/tooltip-truncation-do-light-a2ce43a7c4e7c317abdc2531a3e248fbffd38284dfca3887349f3ab4b82bd26d.png";